import SudokuCell from '../models/SudokuCell'
import api from '@puzzleapps/shared/src/utils/api'

import {
    state as baseState,
    getters as baseGetters,
    actions as baseActions,
    mutations as baseMutations,
} from '@puzzleapps/shared/src/store/modules/grid'



const state = {
    ...baseState,
    /**
     * An array of question data:
     * 
     * answer: "In The Heat Of The Night"
     * choices: (3) ['All The Young Men', 'To Sir, With Love', 'A Patch Of Blue']
     * question: "\"They Call Me Mister Tibbs\" is the sequel to which film?"
     * question_id: 122
     */
    triviaData: null,
}

const getters = {
    ...baseGetters,
}

const actions = {
    ...baseActions,

    fetchPuzzle({ commit, dispatch, rootState, rootGetters }) {
        commit('SET_LOADED', false)
        commit('SET_TRIVIA_DATA', null)
        
        return new Promise((resolve, reject) => {

            // let puzzleId = rootState.game.puzzleId
            // if (!puzzleId) throw new Error('Puzzle id must be specified.')

            const cat = rootGetters['game/getCategoryById'](rootState.game.puzzleId)

            api.triviaData(window.PE_CLIENTAPP_ID, cat.urlParam)
                .then(data => {
                    if (process.env.NODE_ENV === 'development') {
                        console.log(data)
                    }
                    commit('SET_TRIVIA_DATA', data)
                    // dispatch('loadUserDataFromLocal', puzzleId)
                    commit('SET_LOADED', true)
                    resolve(data)
                })     
                .catch(err => reject(err))
        })
    },

}

const mutations = {
    ...baseMutations,

    SET_TRIVIA_DATA(state, json) {
        state.triviaData = json
    },

}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}